import _ from 'lodash';
import Wire from './wire';

export default class Contributor {
  /* eslint-disable camelcase */
  constructor(source) {
    Object.assign(this, source || {
      id: null,
      name: '',
      company: '',
      wires: [],
      active: true,
    });

    this.wires = this.wires.map(w => new Wire(w));
  }

  get sent_contact_count() {
    return _(this.wires).sumBy(w => w.sent_contact_count);
  }

  get unsent_contact_count() {
    return _(this.wires).sumBy(w => w.unsent_contact_count);
  }

  get total_contact_count() {
    return this.sent_contact_count + this.unsent_contact_count;
  }
  /* eslint-enable camelcase */
}
